// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Overlay_overlay__8oSP5 {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: var(--mantine-radius-md);
  background-color: rgba(255, 255, 255, 0.5);
}

.Overlay_upgradeText__pgow7 {
  font-size: 0.875rem;
}

@media screen and (min-width: 75em) {
  .Overlay_upgradeText__pgow7 {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Overlay/index.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;EACA,SAAA;EACA,QAAA;EACA,uCAAA;EACA,0CAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;AACF","sourcesContent":[".overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  left: 1px;\n  top: 1px;\n  border-radius: var(--mantine-radius-md);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.upgradeText {\n  font-size: 0.875rem;\n}\n\n@media screen and (min-width: 75em) {\n  .upgradeText {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `Overlay_overlay__8oSP5`,
	"upgradeText": `Overlay_upgradeText__pgow7`
};
export default ___CSS_LOADER_EXPORT___;
